import { trackEvent } from '@patrianna/analytics'
import { Facebook, HomeOutline, LoginVariant } from '@patrianna-icons/material-icons'
import { usePathname, useSearchParams } from 'next/navigation'

import { connectFacebook } from 'analyticActions/facebook/actions'
import { IS_BRAND_PULSZ } from 'config/brands'
import ROUTES from 'config/routes.json'
import DarkThemeSwitch from 'containers/DarkThemeSwitcher'
import MenuItem from 'containers/Menu/MenuItem'
import MenuLink from 'containers/Menu/MenuLink'
import { useRouterPushWithCallback } from 'containers/NavigationProvider'
import { useBuilderData } from 'hooks/useBuilderCMSData'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { logOut } from 'store/modules/auth/actions'
import { facebookConnectedSelector, isLoggedInSelector } from 'store/modules/user/selectors'
import desktopLinks from 'temp/desktopLinks.json'
import { INTERNAL_GAME_NAVIGATION, setDataToSessionStorage } from 'utils/sessionStorage'

import AccountInfo from '../AccountInfo'
import LoyaltyStatus from '../components/LoyaltyStatus'
import MenuFooter from '../MenuFooter'
import getLinks from '../utils'

import classes from './styles.module.scss'

function MenuDesktop() {
  const routerPush = useRouterPushWithCallback()
  const query = useSearchParams()
  const pathname = usePathname()
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const facebookConnected = useAppSelector(facebookConnectedSelector)
  const { builderData: promoCategories } = useBuilderData(process.env.MODEL_PROMO_CATEGORIES)
  const promoCategoriesPaths = promoCategories.map((item) => item.data.pathname)

  const dispatch = useAppDispatch()

  const links = getLinks(desktopLinks)
  const isHomeActive = pathname?.includes('/home')

  const handleTrackEvent = (targetName: string) => {
    trackEvent(`main_menu_${targetName}_button_click`)
  }

  if (!appInitialized) {
    return null
  }

  return (
    <>
      {isLoggedIn && (
        <div className={classes.accountInfo}>
          <AccountInfo handleTrackEvent={handleTrackEvent} />
        </div>
      )}

      <div className={classes.menuContainer}>
        {IS_BRAND_PULSZ && isLoggedIn && <LoyaltyStatus />}

        <MenuItem
          text='Home'
          href={ROUTES.HOME}
          icon={HomeOutline}
          onClick={() => handleTrackEvent('home')}
          dataTestId='menu-link-home'
          isActive={isHomeActive}
        />

        {links.map((i) => (
          <MenuLink
            {...i}
            promoCategoriesPaths={promoCategoriesPaths}
            key={i.id}
            dataTestId={`menu-link-${i.name}`}
            onClick={() => {
              i?.onClick?.()
              handleTrackEvent(i.name)
              if (i.text.toLowerCase().trim() === 'bingo') {
                setDataToSessionStorage(INTERNAL_GAME_NAVIGATION, 'true')
              }
            }}
          />
        ))}

        {Boolean(isLoggedIn && !facebookConnected) && (
          <MenuItem
            dataTestId='menu-link-connect_facebook'
            text='Connect Facebook'
            icon={Facebook}
            onClick={() => {
              dispatch(connectFacebook(routerPush, query, pathname))
              handleTrackEvent('connect_facebook')
            }}
          />
        )}

        <DarkThemeSwitch handleTrackEvent={handleTrackEvent} />

        {isLoggedIn && (
          <MenuItem
            data-testid='menu-link-log-out'
            text='Logout'
            icon={LoginVariant}
            onClick={() => {
              dispatch(logOut())
              handleTrackEvent('logout')
            }}
          />
        )}
      </div>

      <MenuFooter handleTrackEvent={handleTrackEvent} />
    </>
  )
}

export default MenuDesktop
